import {blogTypes} from "../types/blogTypes";

const initState = {
    posts: [],
    categories: [],
    postsIsLoading: true,
    postsNotFound: false,
    postsCount: 0,
    postDetailsNotFound: false,
    currentPage: 1,
    nextPage: 0,
    lastPage: 1,
    tags: [],
    postComments: [],
    postTags: null,
    postReplies: [],
    addingComment: false,
    currentPost: null,
    currentPostIsLoading: true,
};


const blogReducer = (state = initState, action) => {
    switch (action.type) {
        case blogTypes.GET_POSTS_LIST :
            state = {
                ...state,
                postsIsLoading: false,
                posts: action.payload.posts.posts,
                currentPage: action.payload.posts.current,
                nextPage: action.payload.posts.next,
                lastPage: action.payload.posts.last,
                categories: action.payload.categories,
                tags: action.payload.tags,
            };
            break;
        case blogTypes.GET_POST_DETAILS :
            state = {
                ...state,
                currentPost: action.payload.post,
                postComments: action.payload.comments,
                postTags: action.payload.post.tags,
                postReplies: action.payload.replies,
                categories: action.payload.categories,
                tags: action.payload.tags,
                currentPostIsLoading: false,
                postsIsLoading: false,
            }
            break;
        case blogTypes.SEND_BLOG_COMMENT :
            state = {
                ...state,
                postComments: action.payload.comments,
                postReplies: action.payload.replies,
            }
            break;
        case blogTypes.GET_POST_NOT_FOUND:
            state = {
                ...state,
                postsNotFound: action.payload,
            };
            break;
        case blogTypes.GET_POST_DETAILS_NOT_FOUND:
            state = {
                ...state,
                postDetailsNotFound: action.payload,
            };
            break;
        case blogTypes.ADDING_COMMENT_STATUS:

            state = {
                ...state,
                addingComment: action.payload,
            };
            break;
        case blogTypes. CLEAR_BLOG_DATA:
            state = {
                ...state,
                posts: [],
                categories: [],
                postsIsLoading: true,
                postsCount: 0,
                currentPage: 1,
                nextPage:0,
                lastPage: 1,
                tags: [],
                currentPost: null,
                currentPostIsLoading: true,
                postsNotFound: false,
                postDetailsNotFound: false,
            };
            break;
        default :
        // do nothing
    }
    return state;
};


export default blogReducer;